import gql from 'graphql-tag';

const getSplashRelationsQuery = gql`
query getSplashTemplateRelations($splashTemplateId: String!) {
  getSplashTemplateRelations(splashTemplateId: $splashTemplateId) {
    pitchTemplateId
    splashTemplateId
  }
}
`;

const getSplashRelations = () => ({
  query: getSplashRelationsQuery,
  module: 'pitch',
  ignoreCache: true,
  buildVariables: (splashTemplateId) => ({ splashTemplateId })
});

export default getSplashRelations;